export const URLS = {
    login: 'user/login',
    register: 'user/register',
    logout: 'user/logout',
    tokenValidation: 'tokenValidation/check',
    getAllCacheLookups: 'refTypes/getAll',    
    getLookup: 'refTypes/getLookup', // /entityType/parentid?
    validateCode: 'validate/ValidateCode', // /entityType/code
    sendSecureLink: 'secureLink/sendSecureLink', // /email
    validateSecureLinkToken: 'secureLink/validateSecureLinkToken', // /token
    resetPassword: 'ResetPassword/ResetPassword', // /token
    getManagersLookup: 'RefTypes/GetManagersLookup',
    exportPDF: 'EmployeeAppraisalExport/ToPdf',
    exportReport: 'EmployeeAppraisal/exportReport', // /companyId
    exportReportsPDF: 'EmployeeAppraisalExport/PrintEmployeeAppraisals',
    printPositionsPDF: 'EmployeeAppraisalExport/PrintPositions',
    // Company
    getCompanyList: 'company/get',
    getCompany: 'company/get', // /companyId
    saveCompany: 'company/save',
    deleteCompany: 'company/delete', // /companyId
    // Department
    getDepartmentList: 'department/get',
    getDepartment: 'department/get', // /departmentId
    saveDepartment: 'department/save',
    deleteDepartment: 'department/delete', // /departmentId
    //Job Level
    getJobLevelList: 'jobLevel/get',
    getJobLevel: 'jobLevel/get',  // /jobLevelId
    saveJobLevel: 'jobLevel/save',
    deleteJobLevel: 'jobLevel/delete', // /jobLevelId
    // Employee
    getEmployeeList: 'employee/get',
    getEmployee: 'employee/get',  // /employeeId
    saveEmplyee: 'employee/save',
    deleteEmployee: 'employee/delete',  // /employeeId
    importEmployee: 'employee/importEmployee',
    // Position
    getPositionList: 'position/get',
    getPosition: 'position/get',  // /positionId
    savePosition: 'position/save',
    deletePosition: 'position/delete',  // /positionId
    checkFactorCodes: 'position/checkFactorCodes',
    // Form
    getFormList: 'form/get',
    getForm: 'form/get',  // /formId
    saveForm: 'form/save',
    deleteForm: 'form/delete',  // /formId
    // Rating
    getRatingList: 'rating/get',
    getRating: 'rating/get', // /ratingId
    saveRating: 'rating/save',
    deleteRating: 'rating/delete', // /ratingId
    // Employee Apprasial
    filterEmployeeApprasial: 'employeeappraisal/filter',
    getEmployeeAppraisal: 'employeeappraisal/get', // /employeeAppraisalId
    saveEmployeeAppraisal: 'employeeappraisal/saveDetail',
    calculateRating: 'employeeappraisal/calculate',
    approveReview: 'employeeappraisal/approve',
    // Profile
    getUserProfile: 'profile/get',
    saveUserProfile: 'profile/save',
    // Clone Entities
    getCloneLookup: 'cloneEntity/getRefEntityLookup',  //LookupRequestViewModel
    cloneEntities: 'cloneEntity/cloneEntities',        //CloneEntitiesViewModel
    // Users
    getUsersList: 'UserCompany/getUsers',
    getUser: 'UserCompany/get',   // /userId
    saveUserMapping: 'UserCompany/save',
    saveUsersMapping: 'UserCompany/saveRange',
    getUserCompanies: 'UserCompany/getCompanies',
    //Clear Employees
    clearEmployees: 'Employee/clean',
    clearEmployeeAppraisal: 'EmployeeAppraisal/deleteRange',
    //Recalculation
    recalculateScore: 'EmployeeAppraisal/recalculate', // /companyId
}
